__turbopack_context__.v({
  "chevron": "Historikk-module__EoLiZG__chevron",
  "chevronApen": "Historikk-module__EoLiZG__chevronApen",
  "historikk": "Historikk-module__EoLiZG__historikk",
  "liste": "Historikk-module__EoLiZG__liste",
  "periode": "Historikk-module__EoLiZG__periode",
  "toggle": "Historikk-module__EoLiZG__toggle",
  "visAlle": "Historikk-module__EoLiZG__visAlle",
});
